import 'css-chunksrc/client/common/clipeable/styles.scss';export default {
  "fallback": "_fallback_h62af_1"
};